function skipFrame(cb)
{
  requestAnimationFrame(() => requestAnimationFrame(cb));
}

function makeElement(tag, clazz, parent)
{
  const element = document.createElement(tag);

  if (clazz)
  {
    element.classList.add(...clazz.split(" "));
  }

  if (parent)
  {
    parent.appendChild(element);
  }

  return element;
}

function createToast(data, container)
{
  const toast = makeElement("a", "announcement-toast appears", container);
  const title = makeElement("div", "announcement-toast__preview", toast);

  title.innerHTML = data.preview;
  toast.href = data.link;

  return toast;
}

function showAnnouncement({ data, container, onclose, timeout })
{
  const toast = createToast(data, container);

  function closeToast()
  {
    toast.classList.add("disappears");

    if (onclose)
    {
      onclose();
    }

    toast.ontransitionend = function() {
      toast.ontransitionend = null;
      toast.parentNode.removeChild(toast);
    }
  }

  skipFrame(function()
  {
    toast.classList.remove("appears");
  });

  let tmId = setTimeout(closeToast,
    timeout);

  toast.addEventListener("mouseenter", function()
  {
    clearTimeout(tmId);
  });

  toast.addEventListener("mouseleave", function()
  {
    tmId = setTimeout(closeToast,
    timeout);
  });

  toast.addEventListener("click", closeToast);
}

export { showAnnouncement };